<div class="dashboard">
    <app-counts></app-counts>
    <user-list></user-list>
</div>
